import { Component, HostListener, Inject, OnInit, Optional, signal, ViewChild, WritableSignal } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, NgForm, Validators, ValidationErrors, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, forkJoin, Subject, Subscription } from 'rxjs';
import { estadoFormulario, methodsKinds, molecularKindsValues, reportsKinds, Signals, timesUnitsMap, VetMolKindMap } from '@modelos/enum/enums';
import { dialogData } from '@interfaces/dialog-data.interfase';
import { GetAdminConfigQuery_adminConfigs, GetAssay_assay, GetAssayGroups_assayGroups, GetTechnicalConfigQuery_techConfigs, molecular_kind_values, Roles, timesUnitsEnum, VetMolKind, GetUsersQuery_users } from '@interfaces/operation-result-types';
import { compareObjects } from '@helpers/compareObjects';
import { getErrorMessage } from '@helpers/getErrorMessage';
import { ConfigService } from '@servicios/config.service';
import { valueTakenValidatorGQL } from '@validators/valueTakenValidator_GQL';
import { AssayService } from '@servicios/assay/assay.service';
import { NotificacionesService } from '@servicios/notificaciones.service';
import { AssayAnaliteService } from '@servicios/assay/assayAnalite.service';
import { multipleSelectFilter, showFormControl, validationBio } from 'app/_sharedFuctions/shared-functions';
import { AuthenticationService } from '@servicios/authentication.service';
import { modalConfig } from 'app/_pipes/modalConfig';
import { LoadOptionsService } from '../../../../_servicios/load_options/load_options.service';
import { SelectChangeEvent } from 'primeng/select';
import { FormTechConfig } from '@featuresModules/techConfigModule/generals/form-tech-config/form-tech-config.component';
import { FormAdminConfigComponent } from '@featuresModules/adminConfigModule/form-admin-config/form-admin-config.component';
import { ConfiguracionesTecnicasService } from '@servicios/configuracionesTecnicas.service';
import { AdminConfigService } from '@servicios/adminConfig.service';
import { Assay, IAssayFormData } from '@modelos/assays.model';
import { Editor, Toolbar } from 'ngx-editor';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-assay',
  templateUrl: './form-assay.component.html',
  styleUrls: ['./form-assay.component.css'],
  providers: [],
  standalone: false
})
export class FormAssayComponent implements OnInit {
  derivedChanges$: Subscription;

  constructor(
    private fb: UntypedFormBuilder,
    private configService: ConfigService,
    public as: AssayService,
    private ns: NotificacionesService,
    public aas: AssayAnaliteService,
    private auth: AuthenticationService,
    private opts: LoadOptionsService,
    private pipeNameComponent: modalConfig,
    private matDialog: MatDialog,
    private cts: ConfiguracionesTecnicasService,
    private acs: AdminConfigService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService
  ) { }

  /* VARIABLES */
  //Formulario
  private initialValues: { [key: string]: any }
  private onEditionData: GetAssay_assay;
  language = this.configService.selectedLanguage;
  form: UntypedFormGroup;
  getErrorMessage = getErrorMessage;
  formControls: { [key: string]: AbstractControl }

  categories = [
    { label: 'Cromatográficos y Separación', value: 'CHROMATOGRAPHY_SEPARATION', icon: 'pi pi-sitemap', description: 'HPLC, GC, TLC y técnicas de separación.' },
    { label: 'Espectroscópicos y Elemental', value: 'SPECTROSCOPY_ELEMENTAL', icon: 'pi pi-bolt', description: 'UV-Vis, FTIR, Absorción Atómica, ICP.' },
    { label: 'Fisicoquímicos Clásicos', value: 'PHYSICOCHEMICAL_CLASSIC', icon: 'pi pi-filter', description: 'pH, volumetría, gravimetría, viscosidad.' },
    { label: 'Microbiológicos y Biológicos', value: 'MICROBIOLOGICAL_BIOLOGICAL', icon: 'pi pi-shield', description: 'Cultivos, PCR, endotoxinas, bioensayos.' },
    { label: 'Estado Sólido y Materiales', value: 'SOLID_STATE_MATERIALS', icon: 'pi pi-box', description: 'Dureza, granulometría, disolución.' },
    { label: 'Desempeño y Estabilidad', value: 'PERFORMANCE_STABILITY', icon: 'pi pi-clock', description: 'Estudios de estabilidad y desempeño.' }
  ];

  methodsKinds = this.filterMethodKinds()
  molecularKinds = Object.keys(molecular_kind_values)
  molecularKindsValues = molecularKindsValues
  reportsKinds = reportsKinds
  VetMolKind = Object.keys(VetMolKind)
  VetMolKindMap = VetMolKindMap
  assayCost = 0
  isBio = validationBio(this.configService.appSettings.general.mode)
  timesUnitsEnum = timesUnitsEnum
  timesUnitsMap = timesUnitsMap
  defaultDelays = this.configService.appSettings.frontend.forms?.assay?.times?.delay?.default
  roles = Object.keys(Roles);

  editor: Editor


  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
  ];

  //Subcripciones y datos externos
  private valueChangesForm$ = new Subscription()

  //Componente
  formTitle: string
  isLoading = false
  isSaving = false
  isCheckingValidators = false
  spinnerMessage = this.language.loading
  dataSavedOnDB = false
  documentEditForm: NgForm
  draft = false
  isShowingDraft = false
  currencyConfig = this.configService.currencyConfig
  observationControlHasFocus = false
  refreshTable$ = new Subject()
  activeTabIndex = '0'

  get currentAssay(): GetAssay_assay | undefined {
    return this.onEditionData || this.as.idSelected;
  }

  preparation_info = new UntypedFormControl('')
  preparation_info_initialValue


  filteredMatrix: WritableSignal<GetTechnicalConfigQuery_techConfigs[]> = signal([])
  matrixOptsSG = {
    name: 'matrixOptsSG',
    filteredValues: this.filteredMatrix,
    params: ['matrix'],
    oldSelectedValues: []
  }


  filteredServiceSuppliers: WritableSignal<GetAdminConfigQuery_adminConfigs[]> = signal([])
  serviceSupplierOptsSG = {
    name: 'serviceSupplierOptsSG',
    filteredValues: this.filteredServiceSuppliers,
    params: ['serviceSuppliers'],
    oldSelectedValues: []
  }


  filteredAssaysGroups: WritableSignal<GetAssayGroups_assayGroups[]> = signal([])
  assaysGroupsOptsSG = {
    name: 'assaysGroupsOptsSG',
    filteredValues: this.filteredAssaysGroups,
    oldSelectedValues: []
  }


  filteredSectors: WritableSignal<GetTechnicalConfigQuery_techConfigs[]> = signal([])
  sectorsOptsSG = {
    name: 'sectorsOptsSG',
    filteredValues: this.filteredSectors,
    oldSelectedValues: []
  }

  filteredAnalysts: WritableSignal<GetUsersQuery_users[]> = signal([])
  analystsOptsSG = {
    name: 'usersOptsSG',
    filteredValues: this.filteredAnalysts,
    oldSelectedValues: []
  }

  filteredSupervisors: WritableSignal<GetUsersQuery_users[]> = signal([])
  supervisorsOptsSG = {
    name: 'usersOptsSG',
    filteredValues: this.filteredSupervisors,
    oldSelectedValues: []
  }


  filteredMethods: WritableSignal<GetAssayGroups_assayGroups[]> = signal([])
  methodsOptsSG = {
    name: 'methodsOptsSG',
    filteredValues: this.filteredMethods
  }


  filteredBioGroups: WritableSignal<GetAssayGroups_assayGroups[]> = signal([])
  bioGroups: GetAssayGroups_assayGroups[] = []
  bioGroupsOptsSG = {
    name: 'bioGroupsOptsSG',
    filteredValues: this.filteredBioGroups
  }


  filteredCualResults: WritableSignal<GetTechnicalConfigQuery_techConfigs[]> = signal([])
  cualResultsOptsSG = {
    name: 'cualResultsOptsSG',
    filteredValues: this.filteredCualResults
  }

  parentSingnals = new BehaviorSubject<Signals>(Signals.PARENT_IS_NOT_SAVED)
  signals = Signals

  /* END VARIABLES */

  @ViewChild('documentEditForm') set content(content: NgForm) {
    if (content) { // initially setter gets called with undefined
      this.documentEditForm = content;
    }
  }

  /*Escucha cuando el usuario presiona la tecla enter y hace next al Subject que controla que se hayan cumplido las validaciones asincronas y luego emite el evento emit del formulario */
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter' && !this.configService?.appSettings?.frontend?.forms?.assay?.textEditor?.active) {
      !this.disbledSaveButton() && !this.observationControlHasFocus ?
        this.documentEditForm.ngSubmit.emit() :
        null
    }
  }

  /* LIFE CICLE HOOK`S */
  ngOnInit() {
    this.editor = new Editor()
    this.isLoading = true;

    this.route.params.subscribe(params => {
      const id = params['assayId'];
      if (id && id !== 'new') {
        this.as.modeForm = estadoFormulario.registroEdicion;
        this.as.getOne({ id: id }).subscribe({
          next: res => {
            this.as.idSelected = res.data.assay;
            this.initDialog(res.data.assay);
          },
          error: err => { this.isLoading = false; console.log(err) }
        });
      } else {
        this.as.modeForm = estadoFormulario.registroNuevo;
        this.initDialog();
      }
    });
  }

  initDialog(_data?: GetAssay_assay) {

    switch (this.as.modeForm) {
      case estadoFormulario.registroNuevo:
        this.formTitle = this.language.newAssay;
        this.onEditionData = this.as.draft
        break;
      case estadoFormulario.registroEdicion:
        this.formTitle = this.language.editAssay;
        this.formTitle = this.language.editAssay;
        this.as.draft && this.as.draft?.id == this.as.idSelected?.id ? this.draft = true : this.draft = false;
        this.onEditionData = _data;
        this.dataSavedOnDB = true;
        this.parentSingnals.next(Signals.PARENT_IS_SAVED)
        break;
      case estadoFormulario.registroMostrar:
        this.formTitle = this.language.showAssay;
        this.onEditionData = _data;
        this.parentSingnals.next(Signals.PARENT_IS_SAVED)
        break;
    }

    // Create form.
    this.form = this.fb.group({
      code: [null, [Validators.required]],
      name: [null, [Validators.required]],
      category: [null],
      abbreviation: [null, []],
      reportName: [],
      reportNameEnglish: [],
      sectors: [[]],
      authorizedAnalysts: [[]],
      supervisors: [[]],
      matrixId: [],
      methodId: [],
      active: [true],
      kind: ["Default"],
      formKind: [[]],
      reportKind: ["Default"],
      observations: [],
      excluded: [false],
      v_: [],
      matrix_v2Ids: [],
      multi_humidity_adjustment: [false],
      derived: [false],
      derivedFrom: [],
      derivedTill: [],
      bioGroupId: [],
      supplier: [],
      groupConclusions: [false],
      molecular_kind: [],
      assayGroupsIds: [[]],
      individualLabel: [false],
      externalValidation: [false],
      externalValidationSource: [],
      autoValidation: [false],
      z_index: [null, [this.nullOrNumber]],
      // autoValidationRoles: [[]],
      adminConfig: this.fb.group({
        timePerReplication: [null, [Validators.pattern(new RegExp('\d*\.?\d*'))]],
        greenDays: [null, [Validators.pattern('[0-9]*')]],
        yellowDays: [null, [Validators.pattern('[0-9]*')]],
        redDays: [null, [Validators.pattern('[0-9]*')]],
        time_unit: [null]
      }),
      defaultResult: [],
      defaultCualResult: []
    },
      {
        validator: this.checkDerived('derivedFrom', 'derivedTill', 'derived', 'supplier')
      }
    )

    if (!_data) {
      this.form.get('adminConfig')?.get('greenDays')?.patchValue(this.defaultDelays.green)
      this.form.get('adminConfig')?.get('yellowDays')?.patchValue(this.defaultDelays.yellow)
      this.form.get('adminConfig')?.get('redDays')?.patchValue(this.defaultDelays.red)
      this.form.get('adminConfig')?.get('time_unit')?.patchValue(this.defaultDelays.unit)
    }

    //Initialize form variables.
    this.formControls = this.form.controls;

    // Load information to form on Edit or Draft.
    if (this.onEditionData) {
      this.patchFormValues(this.onEditionData);
      if (this.as.modeForm == estadoFormulario.registroMostrar) this.form.disable();
    }
    // Save initial form values.
    this.initialValues = this.form.value

    //Set form´s validators.
    this.setFormValidators()

    //Subscripcions
    this.formSubscriptions();

    const opts_required = [this.matrixOptsSG, this.methodsOptsSG, this.assaysGroupsOptsSG, this.sectorsOptsSG, this.bioGroupsOptsSG, this.serviceSupplierOptsSG, this.cualResultsOptsSG, this.analystsOptsSG, this.supervisorsOptsSG]
    let optsToLoad = this.opts.loadOptions(opts_required)

    forkJoin(optsToLoad).subscribe({
      complete: () => {
        this.isLoading = false
        const initialSectors = this.form.get('sectors').value || [];
        this.filterUsersBySectors(initialSectors);
      },
      error: err => { console.error(err), this.isLoading = false }
    })

  }

  ngOnDestroy() {
    this.valueChangesForm$.unsubscribe();
    this.derivedChanges$.unsubscribe();
  }
  /* END LIFE CICLE HOOK´S */

  formSubscriptions() {
    this.valueChangesForm$.add(
      this.form.valueChanges.subscribe((value: GetAssay_assay) => {
        this.dataSavedOnDB = compareObjects(value, this.initialValues, { ignoreEmptyValues: true }) && JSON.stringify(this.preparation_info.value) === this.preparation_info_initialValue;
      })
    );

    this.valueChangesForm$.add(
      this.preparation_info.valueChanges.subscribe((value: GetAssay_assay) => {
        this.dataSavedOnDB = compareObjects(this.form.value, this.initialValues, { ignoreEmptyValues: true }) && JSON.stringify(this.preparation_info.value) === this.preparation_info_initialValue;
      })
    );

    this.valueChangesForm$.add(
      this.form.get('sectors').valueChanges.subscribe((sectorsIds: string[]) => {
        this.filterUsersBySectors(sectorsIds || []);
      })
    );

    this.derivedChanges$ = this.form.get('derived').valueChanges.subscribe((newValue) => {
      if (newValue && (this.formControls.derivedFrom)) {
        this.formControls.derivedFrom.patchValue(null)
        this.formControls.derivedTill.patchValue(null)
      }
    });
  }
  /* END SUBSCRIPTIONS */

  filterUsersBySectors(sectorsIds: string[]) {
    const allUsers = this.opts.usersOpts() || [];

    // Si el ensayo no tiene sectores seleccionados, permitimos todos los usuarios
    if (!sectorsIds || sectorsIds.length === 0) {
      this.filteredAnalysts.set(allUsers);
      this.filteredSupervisors.set(allUsers);
      return;
    }

    const filtered = allUsers.filter(user => {
      const userSectors = user.sectors || [];
      // Si el usuario es global (no tiene sectores asignados), lo permitimos siempre
      if (userSectors.length === 0) return true;
      // El usuario debe tener al menos UNO de los sectores asignados al ensayo
      return userSectors.some((sec: any) => sectorsIds.includes(sec.id));
    });

    this.filteredAnalysts.set(filtered);
    this.filteredSupervisors.set(filtered);

    // Remover automáticamente los usuarios asignados que ya no cumplen con los sectores
    const currentAnalysts = this.form.get('authorizedAnalysts').value || [];
    if (currentAnalysts.length > 0) {
      const validIds = filtered.map(u => u.id);
      const cleanedAnalysts = currentAnalysts.filter((id: string) => validIds.includes(id));
      if (cleanedAnalysts.length !== currentAnalysts.length) {
        this.form.get('authorizedAnalysts').patchValue(cleanedAnalysts);
        this.analystsOptsSG.oldSelectedValues = cleanedAnalysts;
        this.ns.emitMessage('Se deseleccionaron analistas que no pertenecen a los sectores elegidos', true, 'warn');
      }
    }
  }

  /* FORM */
  patchFormValues(_value: GetAssay_assay) {

    let data = { ..._value }
    delete data.analites

    this.form.controls.category.patchValue(_value.category);
    this.form.controls.code.patchValue(_value.code);
    this.form.controls.name.patchValue(_value.name);
    this.form.controls.reportName.patchValue(_value.reportName);
    this.form.controls.reportNameEnglish.patchValue(_value.reportNameEnglish);
    this.form.controls.abbreviation.patchValue(_value.abbreviation);
    this.form.controls.sectors.patchValue(_value.sectors?.map(sector => sector.id));
    this.form.controls.authorizedAnalysts.patchValue(_value.authorizedAnalysts?.map(data => data.id));
    this.form.controls.supervisors.patchValue(_value.supervisors?.map(data => data.id));
    this.form.controls.matrixId.patchValue(_value.matrix?.id || "0");
    this.form.controls.methodId.patchValue(_value.method?.id);
    this.form.controls.active.patchValue(_value.active);
    this.form.controls.kind.patchValue(_value.kind);
    this.form.controls.formKind.patchValue(_value.formKind);
    this.form.controls.reportKind.patchValue(_value.reportKind);
    this.form.controls.observations.patchValue(_value.observations);
    this.form.controls.v_.patchValue(_value.v_);
    this.form.controls.excluded.patchValue(_value.excluded);
    this.form.controls.matrix_v2Ids.patchValue(_value.matrix_v2?.map(matrix => matrix.id));
    this.form.controls.multi_humidity_adjustment.patchValue(_value.multi_humidity_adjustment);
    this.form.controls.derived.patchValue(_value.derived);
    this.form.controls.derivedFrom.patchValue(_value.derivedFrom)
    this.form.controls.derivedTill.patchValue(_value.derivedTill)
    this.form.controls.bioGroupId.patchValue(_value.bioGroup?.id)
    this.form.controls.supplier.patchValue(_value.supplier?.id)
    this.form.controls.molecular_kind.patchValue(_value.molecular_kind)
    this.form.controls.groupConclusions.patchValue(_value.groupConclusions)
    this.form.controls.defaultResult.patchValue(_value.defaultResult)
    this.form.controls.defaultCualResult.patchValue(_value.defaultCualResult)
    this.form.controls.assayGroupsIds.patchValue(_value.assayGroupAssays?.map(assayGroupAssays => assayGroupAssays.assayGroup.id));
    this.form.controls.individualLabel.patchValue(_value.individualLabel);
    (this.form.controls.adminConfig as FormGroup).controls.timePerReplication.patchValue(_value.adminConfig?.timePerReplication);
    (this.form.controls.adminConfig as FormGroup).controls.greenDays.patchValue(_value.adminConfig?.greenDays);
    (this.form.controls.adminConfig as FormGroup).controls.yellowDays.patchValue(_value.adminConfig?.yellowDays);
    (this.form.controls.adminConfig as FormGroup).controls.redDays.patchValue(_value.adminConfig?.redDays);
    (this.form.controls.adminConfig as FormGroup).controls.time_unit.patchValue(_value.adminConfig?.time_unit)
    this.form.controls.externalValidation.patchValue(_value.externalValidation);
    this.form.controls.externalValidationSource.patchValue(_value.externalValidationSource);
    this.form.controls.autoValidation.patchValue(_value.autoValidation);
    this.form.controls.z_index.patchValue(_value.z_index);
    this.preparation_info.patchValue(_value.preparation_info ? JSON.parse(_value?.preparation_info) : undefined);
    this.preparation_info_initialValue = _value.preparation_info ? _value?.preparation_info : undefined
  }

  setFormValidators() {
    this.formControls.code.setValidators([Validators.required]);
    this.formControls.code.setAsyncValidators([valueTakenValidatorGQL('code', this.initialValues, this.as, 'assay', 'getOne', true)]);
    this.formControls.name.setValidators([Validators.required]);
    this.formControls.name.setAsyncValidators([valueTakenValidatorGQL('name', this.initialValues, this.as, 'assay', 'getOne', true)]);
    this.formControls.abbreviation.setValidators([Validators.required]);
    this.formControls.abbreviation.setAsyncValidators([valueTakenValidatorGQL('abbreviation', this.initialValues, this.as, 'assay', 'getOne', true)]);

    this.form.updateValueAndValidity({ emitEvent: false });
  }

  dropdownSelectionChange($event: SelectChangeEvent, control: string, signalName: string, filteredSignal: WritableSignal<any>, filteringField = 'id') {
    const finalValue = multipleSelectFilter($event.value, this[signalName].oldSelectedValues, filteredSignal(), filteringField)
    this[signalName].oldSelectedValues = finalValue
    this.form.get(control).patchValue(finalValue)
  }

  buttonConfig(ctrl: string, nameComponent: string, model: string, result_type: string, serviceOptsSG: string, filteredOpts: WritableSignal<any>) {
    this.cts.modeForm = estadoFormulario.registroNuevo;
    this.acs.modeForm = estadoFormulario.registroNuevo;
    let data = undefined;
    let nameObj = {};
    let headerTitle = 'Configuración';

    switch (nameComponent) {
      case "FormTechConfig":
        const link = this.cts.filterLinks(model);
        nameObj = { techConfigLink: link };
        headerTitle = link?.form?.title?.new || 'Configuración Técnica';
        break;
      case "FormAdminConfigComponent":
        const adminLink = this.acs.filterLinks(model);
        nameObj = { adminConfigLink: adminLink };
        headerTitle = adminLink?.form?.title?.new || 'Configuración';
        break;
    }

    const dialogRef = this.dialogService.open(this.pipeNameComponent.transform(nameComponent), {
      header: headerTitle,
      width: '450px',
      position: 'right',
      modal: true,
      styleClass: 'sidebar-dialog',
      data: { data, model: model, ...nameObj }
    });

    dialogRef.onClose.subscribe({
      next: (result) => {
        if (!result?.data) return;
        this.opts.updateOpts(serviceOptsSG, result.data?.[result_type]);
        filteredOpts.set(result.data?.[result_type])

        this.form.get(ctrl)?.updateValueAndValidity({ emitEvent: false })
      }
    })
  }


  /* END FORM */

  /* CRUD FUNCTIONS */
  save(formData: IAssayFormData) {
    this.isSaving = true
    let data = new Assay({ ...formData, preparation_info: this.preparation_info.value })
    if (this.as.modeForm === estadoFormulario.registroNuevo) {
      this.spinnerMessage = this.language.saving + '...';
      this.as.save(data)
        .subscribe({
          next: ({ data: { createAssay } }) => {
            this.isSaving = false
            this.as.idSelected = createAssay as GetAssay_assay
            this.onEditionData = createAssay
            this.refreshTable$.next(true)
            this.ns.emitMessage('Registro guardado')
            this.parentSingnals.next(Signals.PARENT_IS_SAVED)
            this.subcriptionComplete()
            this.opts.updateOpts('assaysOptsSG', [])
            window.history.back()
          },
          error: err => {
            this.isSaving = false
            this.localErrorHandler(err)
          },
        }
        );
    } else {
      this.spinnerMessage = this.language.updating + '...';
      data.v_ = this.onEditionData.v_
      this.as.update(this.onEditionData.id, data)
        .subscribe({
          next: ({ data: { updateAssay } }) => {
            this.isSaving = false
            this.as.idSelected = updateAssay
            this.onEditionData = updateAssay
            this.refreshTable$.next(true)
            this.ns.emitMessage('Registro actualizado')
            this.subcriptionComplete();
            this.initialValues = formData
            this.opts.updateOpts('assaysOptsSG', [])
            window.history.back()
          },
          error: err => {
            this.isSaving = false
            this.localErrorHandler(err)
          }
        }
        )
    }
  };

  /* END CRUD FUNCTIONS */

  /* DIALOG */
  closeDialog() {
    this.draft = false;
    this.as.clearDraft();
    this.as.modeForm = estadoFormulario.registroNuevo;
    this.router.navigate(['../'], { relativeTo: this.route });
  }

  back() {
    this.closeDialog();
  }
  /* END DIALOG */

  /* HELPERS FOR PREMIUM UI */
  getAssayIcon(): string {
    const category = this.form?.get('category')?.value;
    const cat = this.categories.find(c => c.value === category);
    return cat?.icon || 'pi pi-flask';
  }

  getVisualGradient(): string {
    const category = this.form?.get('category')?.value;
    switch (category) {
      case 'CHROMATOGRAPHY_SEPARATION':
        return 'linear-gradient(135deg, #059669 0%, #047857 100%)';
      case 'SPECTROSCOPY_ELEMENTAL':
        return 'linear-gradient(135deg, #f59e0b 0%, #d97706 100%)';
      case 'PHYSICOCHEMICAL_CLASSIC':
        return 'linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%)';
      case 'MICROBIOLOGICAL_BIOLOGICAL':
        return 'linear-gradient(135deg, #8b5cf6 0%, #6d28d9 100%)';
      case 'SOLID_STATE_MATERIALS':
        return 'linear-gradient(135deg, #64748b 0%, #475569 100%)';
      case 'PERFORMANCE_STABILITY':
        return 'linear-gradient(135deg, #06b6d4 0%, #0e7490 100%)';
      default:
        return 'linear-gradient(135deg, #10b981 0%, #047857 100%)';
    }
  }

  getCategoryLabel(categoryValue: string): string {
    return this.categories.find(c => c.value === categoryValue)?.label || '';
  }

  getSelectedMethodName(): string {
    const id = this.form?.get('methodId')?.value;
    if (!id) return '';
    const m = this.opts.methodsOpts()?.find((opt: any) => opt.id === id);
    return m ? `${m.value}${m.code ? ' (' + m.code + ')' : ''}` : '';
  }


  /* PERMISSIONS AND CONTROL VALUES */

  disbledSaveButton() {
    return (!this.form.valid ||
      this.as.modeForm == estadoFormulario.registroMostrar ||
      this.dataSavedOnDB ||
      this.isSaving)
  }

  selectCategory(categoryValue: string) {
    this.form.get('category')?.setValue(categoryValue);
    this.form.get('category')?.markAsDirty();
    this.form.markAsDirty();
  }

  showMolecularKind() {
    return this.form.get('kind').value == methodsKinds.molecular
  }

  showButtonShowDraftData() {
    return (this.draft &&
      !this.isShowingDraft &&
      this.as.modeForm !== estadoFormulario.registroMostrar)
  }

  showButtonHideDraftData() {
    return (this.draft &&
      this.isShowingDraft &&
      this.as.modeForm !== estadoFormulario.registroMostrar)
  }

  showButtonSaveDraftData() {
    return (this.as.modeForm !== estadoFormulario.registroMostrar &&
      !this.dataSavedOnDB)
  }


  hasAnalites() {
    return this.onEditionData?.analites?.length
  }
  /* END PERMISSIONS AND CONTROL VALUES */

  /*OTHER FUNCTIONS */

  observationControlGetFocus() {
    this.observationControlHasFocus = true
  }

  observationControlLostFocus() {
    this.observationControlHasFocus = false
  }



  filterMethodKinds() {
    let filteredOptions: methodsKinds[] = []

    let selectedValues = this.configService.appSettings.frontend.forms.assay.methodKinds.values

    selectedValues.forEach(value => {
      filteredOptions.push(methodsKinds[value])
    })

    return filteredOptions
  }


  checkShowControl(form: string, control: string) {

    let showByConfig = showFormControl(form, control, this.auth.tokenDecoded, this.configService.appSettings)

    return showByConfig
  }


  localErrorHandler(err: Error) {
    this.isSaving = false;
    this.spinnerMessage = 'Cargando...';
    let controlsKeys = Object.keys(this.form.controls)
    controlsKeys.forEach(control => this.form.controls[control].updateValueAndValidity())
    console.log(err);
    throw err
  };

  subcriptionComplete() {
    this.spinnerMessage = 'Cargando...'
    this.formTitle = this.language.editAssay
    this.as.modeForm = estadoFormulario.registroEdicion
    this.dataSavedOnDB = true
    this.isSaving = false;
  };

  getMatrixControlName() {
    let controlName = "matrix_v2Ids"
    return controlName
  }

  multiHumidityAdjustmentActive() {
    return this.configService.appSettings.frontend?.forms?.assay?.multiHumidityAdjustment?.active
  }

  derivedActive() {
    return this.configService.appSettings.frontend?.forms?.assay?.derived?.active
  }
  derivedTillFromActive() {
    return this.configService.appSettings.frontend?.forms?.assay?.derived?.active && !this.formControls.derived.value
  }

  compareWith(a: any, b: any) {
    return a === b
  }

  needsSupplier() {
    if (this.formControls.derived.value || this.formControls.derivedTill.value || this.formControls.derivedFrom.value) return true;
    else return false
  }

  checkDerived(from: string, till: string, isDerived: string, sup: string) {
    return (group: AbstractControl): ValidationErrors | null => {
      const derivedFrom = group.get(from);
      const derivedTill = group.get(till);
      const derived = group.get(isDerived);
      const supplier = group.get(sup);

      // Verifica si esta Derivado y tiene Proveedor
      const isDerivedValid = derived?.value && supplier?.value;

      // Verifica si tiene Derivacion Programada y que tenga las dos fechas con un Proveedor
      const areFromTillValid = derivedFrom?.value && derivedTill?.value && supplier?.value;

      if (isDerivedValid || areFromTillValid) {
        return null;
      }

      if (derivedFrom?.value && !derivedTill?.value) {
        derivedTill?.setErrors({ derivative: true });
      }

      else if (!derivedFrom?.value && derivedTill?.value) {
        derivedFrom?.setErrors({ derivative: true });
      }

      else if ((derived?.value || (derivedFrom?.value && derivedTill?.value)) && !supplier?.value) {
        supplier?.setErrors({ derivative: true });
      }
      return null;
    };
  }



  get adminConfig() {
    return (this.form.get('adminConfig') as FormGroup).controls
  }

  showTimes() {
    return (this.configService.appSettings.frontend.forms?.assay?.times?.timePerReplication?.active ||
      this.configService.appSettings.frontend.forms?.assay?.times?.delay?.active)
  }

  showTimePerReplication() {
    return this.configService.appSettings.frontend.forms?.assay?.times?.timePerReplication?.active
  }

  showDelay() {
    return this.configService.appSettings.frontend.forms?.assay?.times?.delay?.active
  }

  nullOrNumber(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value === null || value === '') return null;

    return !isNaN(Number(value)) ? null : { notNumber: true };
  }



}
